import React from 'react';

import {
  BILLING_PERIOD_TYPE,
  BillingPeriodType,
} from '../../constants/billingPeriodType';
import { LbChip } from '../../../shared/components/ui-components';
import { getHumanizeBillingPeriodType } from '../../utils/getHumanizeBillingPeriodType/getHumanizeBillingPeriodType';

type BillingPeriodTypeChipProps = {
  billingPeriodType: BillingPeriodType;
};

const BillingPeriodTypeChip = ({ billingPeriodType }: BillingPeriodTypeChipProps) => {
  const label = getHumanizeBillingPeriodType(billingPeriodType);

  switch (billingPeriodType) {
    case BILLING_PERIOD_TYPE.MONTHLY:
      return <LbChip label={label} color={'info'} size="small" />;
    case BILLING_PERIOD_TYPE.DAILY:
    default:
      return <LbChip label={label} size="small" />;
  }
};

export { BillingPeriodTypeChip };
